import type { ReactNode } from 'react';
import { Typography, type SxProps, type Theme } from '@mui/material';
import { composeSx } from '../../utils/composeSx';
import { HFBox } from '../HFBox';

export type HFEmptyProps = {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  sx?: SxProps<Theme>;
};

export function HFEmpty({ title, description, action, children, sx }: HFEmptyProps) {
  return (
    <HFBox
      sx={composeSx(
        {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          borderRadius: 2,
          border: '1px dashed',
          borderColor: 'divider',
          px: 2,
          py: 2,
          textAlign: 'center',
          bgcolor: 'background.default',
        },
        sx,
      )}
    >
      {title != null ? (
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
      ) : null}
      {description != null ? (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      ) : null}
      {children}
      {action}
    </HFBox>
  );
}
